import { render, staticRenderFns } from "./ClientLogo.vue?vue&type=template&id=119082ec&scoped=true"
import script from "./ClientLogo.vue?vue&type=script&lang=js"
export * from "./ClientLogo.vue?vue&type=script&lang=js"
import style0 from "./ClientLogo.vue?vue&type=style&index=0&id=119082ec&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119082ec",
  null
  
)

export default component.exports